export default function MotionReleaseBenefit() {
  return (
    <section className="bg-[linear-gradient(115deg,#0b123f,#17247f)] px-[6vw] py-[72px] text-white max-[680px]:px-5 max-[680px]:py-[58px]">
      <div className="mx-auto grid w-[min(1180px,100%)] grid-cols-[1.05fr_0.95fr] items-center gap-[68px] max-[980px]:grid-cols-1 max-[980px]:gap-[22px]">
        <h2 className="m-0 font-figtree text-[clamp(36px,4.5vw,58px)] font-black uppercase leading-[1.02] tracking-[-0.045em]">
          Give your release the full picture.
        </h2>
        <p className="m-0 max-w-[580px] font-open-sans text-[18px] leading-[1.65] text-white/75 max-[680px]:text-[17px]">
          Your release deserves more than a static cover. Add motion artwork for
          Apple Music and Spotify to build a more complete visual package and
          make the most of how your music appears across platforms.
        </p>
      </div>
    </section>
  );
}
